module.exports = __webpack_public_path__ + "img/Move.c5b95264.svg";